export default IconArrowRotaryLastLeft => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-rotary-last-left" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M15 15a3 3 0 1 1 0 -6a3 3 0 0 1 0 6z" />
  <path d="M15 15v6" />
  <path d="M12.5 9.5l-6.5 -6.5" />
  <path d="M11 3h-5v5" />
</svg>`;